// extracted by mini-css-extract-plugin
export var labelBox = "nested-nav-module--label-box--Vc5S1";